
import CheckSVG from "../../svg/checkSVG"

import styles from "./Radio.module.scss"

function Radio({uniqueId,name,checked,onChange,label}) {
  return (
    <fieldset className={`${styles.radio} ${checked ? styles.radioActive : ""}`}>
      <input id={uniqueId} type="radio" name={name} checked={checked} onChange={onChange} />
      <button onClick={onChange}>
        <span className={styles.radioBtn}>
          {checked ? (
            <CheckSVG />
          ) : (
            <div className={styles.emptyRadio} />
          )}
        </span>
        <label htmlFor={uniqueId}>{label}</label>
      </button>
    </fieldset>
  )
}

export default Radio